import { defineAction } from '~/prix'
import { z } from 'zod'
import incentiveDocumentUpdateAction from './incentiveDocumentUpdate.action.json' with { type: 'json' }
import { incentiveDocumentUpdateInputObject } from '../incentiveDocumentObject'

const incentiveDocumentUpdateDefinition = defineAction({
  ...incentiveDocumentUpdateAction,

  input: incentiveDocumentUpdateInputObject,
  output: z.object({}),
})

export default incentiveDocumentUpdateDefinition
